export default __webpack_public_path__ + "static/media/view2.9c44f58c.png";